import { makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import GcpBox from '../gcp-box';
import GcpTypography from '../gcp-typography';
import { GcpVerticalTabComponent } from './content';

interface GcpTabLabelProps {
  value: GcpVerticalTabComponent;
  stage: GcpVerticalTabComponent;
  translation: string;
  Icon: (props: { className: string }) => JSX.Element;
}

const useStyles = makeStyles(
  (theme: Theme) => ({
    active: {
      color: theme.palette.common.ceriseRed,
    },
  }),
  { name: 'GcpTabLabel' }
);

function isActive(active: boolean): 'ceriseRed' | 'black' {
  return active ? 'ceriseRed' : 'black';
}

const GcpTabLabel: FC<GcpTabLabelProps> = (props) => {
  const classes = useStyles();
  const { value, stage, translation, Icon } = props;
  const { t } = useTranslation();

  return (
    <GcpBox alignItems="center" display="flex" gap={2}>
      <Icon
        className={clsx({
          [classes.active]: value === stage,
        })}
      />
      <GcpTypography
        paint={isActive(value === stage)}
        transform="capitalize"
        variant="caption"
      >
        {t(translation)}
      </GcpTypography>
    </GcpBox>
  );
};

export default GcpTabLabel;
